export enum WarehouseTypes {
  Stationary = 1,
  Sleeve = 2,
}
